import React from "react";
import { withRouter } from 'react-router-dom';
import "react-bootstrap-carousel/dist/react-bootstrap-carousel.css";
// import RBCarousel from "react-bootstrap-carousel";
import { Container, Row, Col, Carousel } from "react-bootstrap";
// , ToggleButton, ToggleButtonGroup
//import Col from "react-bootstrap/Col";
import "./style.css";
import Button from 'react-bootstrap/Button';
import ActivityIndicator from "components/ActivityIndicator/ActivityIndicator";
import { apiUrl, presentation_Creation_API, myHeaders_Autorized } from 'Api/Api';
import axios from 'axios';
import AudioTimer from './AudioTimer';
import Form from "react-bootstrap/Form";
import { org_friendly_url, user_Status_Ver } from 'Api/Api';
import sanitize from 'sanitize-filename';
import { local_routes } from 'utils/Routes';
import { supported_languages } from 'utils/supported_languages';

//import AudioRecorder from './AudioRecorder/AudioRecorder';
import VideoRecorder from './VideoRecorder/VideoRecorder';

//import "react-bootstrap-carousel/dist/react-bootstrap-carousel.css";

class Presentation extends React.PureComponent {
  
  constructor(props) {

    super(props);
    this.state = {
      stream_ready: false,
      show_video_stream: false,
      showing_video_stream: false,
      loading: true,
      saving: false,
      message: '',
      fail_message: '',
      ok_to_finish: false, // do we have enough audio to finish/upload?
      audioMimeType: null, // returned from RecorderService so <audio>/<video> tag knows what to display
      force_timerCount: 0, // for forcing AudioTimer to a different slide
      
      //current_slide: 1, // for recording per-slide, controlled by dropdown // UNUSED
      
      carousel_active_slide_index: 0,
      carousel_controls_bool: true,
      presenter_overlay_position: props.presentation_info.presenter_overlay_position || 'bottom_right',
      required_slide_count: props.presentation_info.slide_count || 20,
      seconds_per_slide: props.presentation_info.slide_length || 20,
      max_wrapup_time: 0, // no wrapup time for record per-slide
      slide_indicator: '', // for audio control to display slide number
      showRecordControls: true,
      duration: 0, // recorded/playing audio duration - gotten from AudioTimer
      
      //recorded_duration: 0, // recorded audio duration // deprecated?
      
      autoplay: false, // tells RBCarousel whether to play or not
      //clickArea: null, // recording state value passed to AudioTimer, retrieved from AudioRecorder callback
      modified_slide_image_urls: [], // passed to RBCarousel to show slides during recording

      final_audioOutput: null, // actual raw recorded/uploaded data - entire presentation
      //final_local_file_url: null, // file reference for entire presentation audio control // deprecated?
      audioOutput: null, // actual raw recorded/uploaded data - for one slide
      local_file_url: null, // specifically so audio control can reference - for one slide
      
      new_recording_flag_array: Array.apply(null, Array(props.presentation_info.slide_count || 20)).map(function () {return null;}), // multi-slide recording, to indicate if we need to upload new audio
      audioOutput_array: Array.apply(null, Array(props.presentation_info.slide_count)).map(function () {return null;}), // multi-slide recording, actual raw recorded/uploaded data
      local_file_url_array: Array.apply(null, Array(props.presentation_info.slide_count)).map(function () {return null;}), // multi-slide recording, specifically so audio control can reference

      //videoOutput_array: Array.apply(null, Array(props.presentation_info.slide_count)).map(function () {return null;}), // multi-slide recording, actual raw recorded/uploaded data
      //video_local_file_url_array: Array.apply(null, Array(props.presentation_info.slide_count)).map(function () {return null;}), // multi-slide recording, specifically so audio control can reference

      //audioName: null, // recorded audio filename, received from AudioRecorder
      //videoName: null, // recorded video filename, received from VideoRecorder
      
      //audioOutputValidate: false, // show "please provide valid audio" message
      //audioDelayValidate: false, // show "please use less than 300s for audio delay" message

      //modalLoader: false, // show "audio uploading" message

      delayTime: props.audioType === 'upload_video' ? null : null, // introduction time, set in text field
      audioRecordstatus: null, // passed to AudioRecorder, changed by user clicking "record"/"pause"/"inactive"
      audioChanged: false, // when uploading, was a new file uploaded?
      audio_delay_changed: false,
      language_selection_changed: false,
      languageSelections: supported_languages,

      languageSelection: "US English (en-US)", // default
      audioFileName: null, // audio filename, for display purposes

    };

    this.presenter_overlay_positions = [
      {
        value: 'top_left',
        display: 'Top Left',
      },
      {
        value: 'bottom_left',
        display: 'Bottom Left',
      },
      {
        value: 'top_right',
        display: 'Top Right',
      },
      {
        value: 'bottom_right',
        display: 'Bottom Right',
      }
    ];

    this.workspace_base_url = "";
    if (org_friendly_url) {
      this.workspace_base_url = local_routes.workspace+"/"+org_friendly_url;
    }

    console.log("Presentation constructor",props.audioType,props.presentation_info.language_abbreviation,this.props.presentation_info.slide_count,this.props.slides_array.length);

    /*
    if (props.audioType === 'upload_video' && props.presentation_info.audio_delay) {
      this.state.delayTime = props.presentation_info.audio_delay / 1000;
    }
    */
    
    if (props.presentation_info.language_abbreviation) {
      for (let language_obj of this.state.languageSelections) {
        if (language_obj.type === props.presentation_info.language_abbreviation) {
          this.state.languageSelection = language_obj['language'];
          break;
        }
      }
    }
    
    //if (props.presentation_info.audio_url) {
    //  let tmp_array = props.presentation_info.audio_url.split('/');
    //  this.state.audioFileName = tmp_array[tmp_array.length-1];
    //} 
    
    if (props.presentation_info.presenter_video_url) {
      let tmp_array = props.presentation_info.presenter_video_url.split('/');
      this.state.audioFileName = tmp_array[tmp_array.length-1];
    }
    
    
    if (props.audioType === 'upload' || props.audioType === 'upload_video') {
      //this.state.slide_indicator = 'Cover Slide / Introduction';
    }

    this.audioTimer_handler = this.audioTimer_handler.bind(this);
    
    this.rb_carousel_ref = React.createRef();
    
    //this.video_element = React.createElement('video', {
    //  srcObject: null,
    //  src: null,
    //  controls: false
    //});
    
    //this.recorded_audio_ref = React.createRef(); // to interact with uploaded audio
    this.recorded_video_ref = React.createRef(); // to interact with uploaded video
    this.prev_recorded_video_ref = React.createRef(); // used to make React work when switching overlay positions
    
    // for audioType 'record_video'
    //this.max_recording_duration = (this.state.required_slide_count * this.state.seconds_per_slide) + this.state.max_wrapup_time; // seconds
    
    // for carousel display    
    let modified_slide_image_urls = [];
    if (props.slides_array) {
      let slide_dimensions = '640x360'

      for (let slide_obj of props.slides_array) {

        let image_mod_string = "padblack_"+slide_dimensions;
        let array = slide_obj.image_url.split("/");
        if (props.presentation_info.pad_color) {
          image_mod_string = "pad"+this.props.presentation_info.pad_color+"_"+slide_dimensions;
        }
        modified_slide_image_urls.push(`${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/${image_mod_string}/${array[5]}`);
      }
      
      if (props.presentation_info.image_url && (props.audioType === 'upload')) {
        // add cover image to beginning of slide array
        let image_mod_string = "padblack_"+slide_dimensions;
        let array = props.presentation_info.image_url.split("/");
        if (props.presentation_info.pad_color) {
          image_mod_string = "pad"+this.props.presentation_info.pad_color+"_"+slide_dimensions;
        }
        modified_slide_image_urls.unshift(`${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/${image_mod_string}/${array[5]}`);
        //modified_slide_image_urls.unshift(props.presentation_info.image_url);
        //if (this.state.delayTime !== null) {
          this.state.carousel_active_slide_index = 1;
        //}
      }

      this.state.modified_slide_image_urls = modified_slide_image_urls;
    }

    //this.auto_play_interval = undefined;
    
    //this.previous_seek_pos = 0; // to prevent infinite onSeeking loop
  }
  
  audioTimer_handler (duration_ms) {
    //console.log("audioTimer_handler",duration);
    this.setState({ duration: (duration_ms / 1000), force_timerCount: null });
    
    let tmp_slide_number;
    if (this.state.delayTime !== null) {
      tmp_slide_number = Math.floor(((duration_ms / 1000) - this.state.delayTime) / this.state.seconds_per_slide) + 1;
    } else {
      tmp_slide_number = Math.floor((duration_ms / 1000) / this.state.seconds_per_slide);
    }

    console.log("audioTimer_handler",this.state.audioRecordstatus,duration_ms,tmp_slide_number,this.state.carousel_active_slide_index);

    //this.setState({
    //  duration,
    //  force_timerCount: null
    //});
    
    if (this.props.audioType === 'record_video') {
      // move slides here

      let force_timerCount = null;
      let tmp_audioRecordstatus = this.state.audioRecordstatus;
      
      /*
      let tmp_recorded_duration = 0;
      if (this.state.audioRecordstatus === 'recording') {
        tmp_recorded_duration = duration_ms / 1000;
      }
      */
      
      let tmp_required_slide_count = this.state.required_slide_count;
      if (this.state.delayTime !== null) {
        tmp_required_slide_count++;
      }
      
      if (tmp_slide_number >= tmp_required_slide_count) {
        // if they are at the end
        console.log("audioTimer_handler finish last slide",tmp_slide_number);
        //tmp_slide_number = this.state.required_slide_count - 1;
        tmp_slide_number = 0;
        force_timerCount = 0;
        
        if (tmp_audioRecordstatus === 'recording') {
          tmp_audioRecordstatus = 'finished';
        } else {
          tmp_audioRecordstatus = null;
        }
        if (!this.recorded_video_ref.current.paused) {
          this.recorded_video_ref.current.pause();
        }
        this.recorded_video_ref.current.currentTime = 0;
      }

      // do we have enough video to finish/save?
      // let user finish recording if they have video for at least one slide
      let ok_to_finish = this.state.ok_to_finish;
      /*
      if (tmp_audioRecordstatus === 'recording' || tmp_audioRecordstatus === 'recording_paused') {
        if (Math.floor(duration_ms / 1000) > this.state.seconds_per_slide) {
          ok_to_finish = true;
        } else {
          ok_to_finish = false;
        }
      }
      */
        
      this.setState({
        ok_to_finish,
        //recorded_duration: tmp_recorded_duration,
        //duration,
        force_timerCount,
        carousel_active_slide_index: tmp_slide_number,
        audioRecordstatus: tmp_audioRecordstatus
      });

    } else if (this.props.audioType === 'record_video_per_slide') {
      let force_timerCount = null;
      let tmp_audioRecordstatus = this.state.audioRecordstatus;
      
      /*
      let tmp_recorded_duration = 0;
      if (this.state.audioRecordstatus === 'recording') {
        tmp_recorded_duration = duration_ms / 1000;
      }
      */
      
      if (tmp_slide_number !== 0 && this.state.carousel_active_slide_index !== tmp_slide_number) {
        // if we are recording per slide, did we finish slide?
        console.log("audioTimer_handler finish slide",tmp_slide_number);
        tmp_slide_number = tmp_slide_number-1;
  
        //force_timerCount = 0;
        if (tmp_audioRecordstatus === 'recording') {
          tmp_audioRecordstatus = 'finishslide';
          //force_timerCount = 0;
          force_timerCount = tmp_slide_number * this.state.seconds_per_slide;
        } else if (tmp_audioRecordstatus === 'playing') {
          //force_timerCount = 0;
          force_timerCount = tmp_slide_number * this.state.seconds_per_slide;
          tmp_audioRecordstatus = 'finishslide';
        }
      }
      
       this.setState({
          //ok_to_finish,
          //recorded_duration: tmp_recorded_duration,
          //duration,
          force_timerCount,
          carousel_active_slide_index: tmp_slide_number,
          audioRecordstatus: tmp_audioRecordstatus
        });
 
        //this.setState({current_slide:tmp_slide_number+1});
      
    }

  }
  
  onKeyPress(event) {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
     if (/\+|-/.test(keyValue)) {
       event.preventDefault();
     }
  }

  // slide dropdown for record video-per-slide
  handleSlideChange = (e) => {
    this.onSlideChange(e.target.value-1)  ;
  }
  
  /*
  handleSlideChange = (e) => {
    let new_timerCount = (e.target.value-1) * this.state.seconds_per_slide;
    console.log("handleSlideChange",this.state.audioRecordstatus,e.target.value,new_timerCount,this.state.local_file_url_array[e.target.value-1]);
    if (this.state.local_file_url_array[e.target.value-1]) {
      // if we have already recorded this slide, show the audio control
      this.recorded_video_ref.current.srcObject = null;
      this.recorded_video_ref.current.src = this.state.local_file_url_array[e.target.value-1];
      //this.recorded_video_ref.current.controls = true;
      this.prev_recorded_video_ref.current = this.recorded_video_ref.current;
      this.setState({
        audioRecordstatus: 'finishslide',
        carousel_active_slide_index: e.target.value-1,
        local_file_url: this.state.local_file_url_array[e.target.value-1],
        audioOutput: this.state.audioOutput_array[e.target.value-1],
        //current_slide: e.target.value,
        force_timerCount: new_timerCount,
      });
    } else {
      // no audio recorded for this slide yet
      this.recorded_video_ref.current.srcObject = null;
      this.recorded_video_ref.current.src = null;
      //this.recorded_video_ref.current.controls = false;
      this.prev_recorded_video_ref.current = this.recorded_video_ref.current;
      this.setState({
        audioRecordstatus: 'finishslide',
        carousel_active_slide_index: e.target.value-1,
        local_file_url: null,
        audioOutput: null,
        //current_slide: e.target.value,
        audioOutput: null,
        force_timerCount: new_timerCount,
      });
    }
  }
  */

  handleOverlayPositionChange = (e) => {
    let new_timerCount = this.state.carousel_active_slide_index * this.state.seconds_per_slide;
    console.log("handleOverlayPositionChange",e.target.id,e.target.value,this.recorded_video_ref.current.srcObject);
    this.prev_recorded_video_ref.current = this.recorded_video_ref.current;
    this.setState({
        presenter_overlay_position: e.target.value,
        //overlay_position_changed: true,
        //audioRecordstatus: 'finishslide',
        force_timerCount: new_timerCount,
    });
  }

  async componentDidUpdate() {
    // this is a necessary hack so react updates the ref
    //console.log("componentDidUpdate",this.recorded_video_ref.current.src,this.prev_recorded_video_ref.current.src,this.recorded_video_ref.current.srcObject,this.prev_recorded_video_ref.current.srcObject);
    if (this.recorded_video_ref.current && this.prev_recorded_video_ref.current) {
      if (this.recorded_video_ref.current.srcObject !== this.prev_recorded_video_ref.current.srcObject || this.recorded_video_ref.current.src !== this.prev_recorded_video_ref.current.src) {
        console.log(" setting recorded_video_ref to prev");
        //this.recorded_video_ref.current = this.prev_recorded_video_ref.current;
        if (this.state.audioRecordstatus !== 'playing') {
          this.recorded_video_ref.current.muted = true;
        }
        this.recorded_video_ref.current.srcObject = this.prev_recorded_video_ref.current.srcObject;
        this.recorded_video_ref.current.src = this.prev_recorded_video_ref.current.src;
        this.recorded_video_ref.current.controls = this.prev_recorded_video_ref.current.controls;
        //this.recorded_video_ref.current.paused = this.prev_recorded_video_ref.current.paused;
        //this.recorded_video_ref.current = this.prev_recorded_video_ref.current;
        //console.log(" recorded_video_ref",this.recorded_video_ref.current.srcObject);
        //await this.recorded_video_ref.current.play();
        
        //console.log(" paused?",this.state.audioRecordstatus);
        
        if (this.state.show_video_stream || this.state.audioRecordstatus === 'playing' || this.state.audioRecordstatus === 'recording') {
          await this.recorded_video_ref.current.play();
        } else {
          await this.recorded_video_ref.current.play();
          this.recorded_video_ref.current.pause();
        }
        
        
        //this.recorded_video_ref.current.pause();
        //this.recorded_video_ref.current.load();
      }
    }
  }

  handleLanguageChange = (e) => {
    this.setState({ languageSelection: e.target.value, language_selection_changed: true });
  }
  
  
  handleAudioDelayChange = (e) => {
    //console.log("handleAudioDelayChange",this.recorded_audio_ref.current.paused);

    this.setState({
      carousel_active_slide_index: 0,
      delayTime: e.target.value,
      audio_delay_changed: true,
      //slide_indicator:'Cover Slide / Introduction'
    });

    //this.rb_carousel_ref.current.goToSlide(0);
    //this.recorded_audio_ref.current.currentTime = 0;
    //this.recorded_video_ref.current.currentTime = 0;
    //this.onCarouselSlideChange(0);

    //if (!this.recorded_audio_ref.current.paused) {
    //  this.startRecording(e.target.value);
    //}
  }
  

  componentWillUnmount() {
    clearInterval(this.auto_play_interval);
    this.setState({ audioRecordstatus: 'inactive' });
  }

  componentDidMount = async function () {
    // Check if we already have per-slide-video
    
    if (this.props.audioType === 'record_video_per_slide') {
      let tmp_local_file_url_array = [...this.state.local_file_url_array];
      let got_all_slides = true;
      for (let i = 0; i < this.props.slides_array.length; i++) {
        let slide_obj = this.props.slides_array[i];
        if (slide_obj.presenter_video_url) {
          // get the video to display locally
          tmp_local_file_url_array[i] = slide_obj.presenter_video_url;
        } else {
            got_all_slides = false;
        }
      }
      console.log("componentDidMount record_video_per_slide slides_array",got_all_slides,this.props.slides_array);
      console.log(" local_file_url_array", tmp_local_file_url_array);
      //console.log("video ref?",this.recorded_video_ref.current);
      if (tmp_local_file_url_array[0]) {
        //this.video_element.srcObject = null;
        //this.video_element.src = tmp_local_file_url_array[0];
        this.recorded_video_ref.current.srcObject = null;
        this.recorded_video_ref.current.src = tmp_local_file_url_array[0];
        //this.recorded_video_ref.current.controls = true;
        this.prev_recorded_video_ref.current = this.recorded_video_ref.current;
      } else {
        this.recorded_video_ref.current.srcObject = null;
        this.recorded_video_ref.current.src = null;
        this.recorded_video_ref.current.controls = false;
        this.prev_recorded_video_ref.current = this.recorded_video_ref.current;
      }
      this.setState({
        //carousel_active_slide_index: 0,
        //current_slide: 1,
        ok_to_finish: got_all_slides,
        local_file_url: tmp_local_file_url_array[0] || null,
        local_file_url_array: tmp_local_file_url_array,
      })
      return;
    }

    if (this.props.audioType === 'record_video') {
      let tmp_local_file_url;
      //if (this.props.presentation_info.presenter_video_url) {
      //  tmp_local_file_url = this.props.presentation_info.presenter_video_url;
      //}
      
      console.log("componentDidMount record_video local_file_url", tmp_local_file_url);
      //console.log("video ref?",this.recorded_video_ref.current,this.recorded_video_ref.current.duration);
      if (tmp_local_file_url) {
        //this.video_element.srcObject = null;
        //this.video_element.src = tmp_local_file_url_array[0];
        this.recorded_video_ref.current.srcObject = null;
        this.recorded_video_ref.current.src = tmp_local_file_url;
        console.log(" duration",this.recorded_video_ref.current.duration);
        if (this.recorded_video_ref.current.duration === Infinity || isNaN(this.recorded_video_ref.current.duration)) {
          console.log( " Forcing browser to get video duration");
          this.recorded_video_ref.current.currentTime = 100000; // force browser to update to real duration
        }
        this.recorded_video_ref.current.currentTime = 0;
        //this.recorded_video_ref.current.controls = true;
        this.prev_recorded_video_ref.current = this.recorded_video_ref.current;
      } else {
        this.recorded_video_ref.current.srcObject = null;
        this.recorded_video_ref.current.src = null;
        //this.recorded_video_ref.current.controls = false;
        this.prev_recorded_video_ref.current = this.recorded_video_ref.current;
      }
      this.setState({
        //current_slide: 1,
        local_file_url: tmp_local_file_url || null,
        //local_file_url_array: tmp_local_file_url_array,
        //clickArea: 'paused'
      });
      return;
    }
    
    if (this.props.audioType === 'upload_video') {
      let ok_to_finish = false;
      let tmp_local_file_url;
      if (this.props.presentation_info.presenter_video_url) {
        tmp_local_file_url = this.props.presentation_info.presenter_video_url;
      }
      console.log("componentDidMount upload_video tmp_local_file_url", tmp_local_file_url);
      if (tmp_local_file_url) {
        this.recorded_video_ref.current.srcObject = null;
        this.recorded_video_ref.current.src = tmp_local_file_url;
        
        // JBB - this takes some hacking to get the duration
        if (isNaN(this.recorded_video_ref.current.duration) || this.recorded_video_ref.current.duration === Infinity) {
          this.recorded_video_ref.current.onloadedmetadata = (async () => {
            this.recorded_video_ref.current.currentTime = 1000000;
            this.recorded_video_ref.current.ontimeupdate = (async () => {
              this.recorded_video_ref.current.ontimeupdate = null;
              console.log("Retrieved video duration (componentDidMount)",this.recorded_video_ref.current.duration)
              this.recorded_video_ref.current.currentTime = 0;
              this.prev_recorded_video_ref.current = this.recorded_video_ref.current;
            });
          });
        } else {
          this.recorded_video_ref.current.currentTime = 0;
          this.prev_recorded_video_ref.current = this.recorded_video_ref.current;
        }
        ok_to_finish = true;
      } else {
        this.recorded_video_ref.current.srcObject = null;
        this.recorded_video_ref.current.src = null;
        this.prev_recorded_video_ref.current = this.recorded_video_ref.current;
      }
      this.setState({
        ok_to_finish,
        local_file_url: tmp_local_file_url || null,
      });


    }
    
    // Edit PK Audio upload
    /*
    if (this.props.pkAudio !== undefined && this.props.audioType === 'upload') {
      let audio= this.props.pkAudio;
      var self=this;

      var xhr = new XMLHttpRequest();
      xhr.open("GET", audio, true);
      xhr.responseType = "arraybuffer";
      xhr.onload = function () {
        var arrayBufferView = new Uint8Array(this.response);
        var blob = new window.Blob([arrayBufferView], { type: 'audio/mp3' });
        var urlCreator = window.URL || window.webkitURL;
        let local_file_url = urlCreator.createObjectURL(blob);
        self.setState({
          local_file_url,
          audioDelayValidate: false
        });
      };
      xhr.send();
    }
    */
  }

  TriggerCreateVideo = async () => {
    console.log("TriggerCreateVideo");
    
    this.setState({
      message: 'Working...',
      saving: true,
      fail_message: null
    });

    // upload new presenter video
    let new_audio_found_and_uploaded = await this.AudioPushMet();
    
    if (!new_audio_found_and_uploaded) {
      /*
      // bailout
      this.setState({
        message: '',
        fail_message: 'No Video Changes Detected',
        saving: false
      });
      return;
      */
    }
    if (!this.state.ok_to_finish) {
      this.setState({
        message: null,
        fail_message: 'Missing one or more slide videos - please make sure video has been recorded for every slide before finishing',
        saving: false
      });
      return;
    } else {
      //this.setState({
        //message: 'Working...',
        //saving: true,
        //fail_message: null
      //});
    }


    // if user is not verified, they can't publish/create videos and transcriptions
    if (user_Status_Ver !== "1") {
      console.log("User is not verified - cannot publish (create video/transcript)");
      this.props.next();
      return;
    }
    
    //return; // for testing
    
    // do we need to create new video?
    console.log("Trigger Decision",this.props.slidesChanged,this.state.audioChanged,this.state.language_selection_changed,this.state.audio_delay_changed,this.props.audioType);
    let make_video_bool = false;
    let make_transcript_bool = false;
    let video_assembly_method = 'presentation_video';
    if (this.props.slidesChanged) {
      make_video_bool = true;
    }
    
    /*
    if (this.props.audioType === 'record' || this.props.audioType === 'record_per_slide') {
      make_video_bool = true;
      make_transcript_bool = true;
    }
    
    if (this.props.audioType === 'upload' && (this.state.audioChanged || this.state.language_selection_changed || this.state.audio_delay_changed)) {
      make_video_bool = true;
      make_transcript_bool = true;
    }
    */

    if (this.props.audioType === 'upload_video' && (this.state.audioChanged || this.state.language_selection_changed || this.state.audio_delay_changed)) {
      // for record-video, we have to make a .mp3 via process_video in order to get transcript (because AWS Transcribe does not support .webm); so don't trigger here
      make_video_bool = true;
    }
    
    if (this.props.audioType === 'record_video') {
      // for record-video, we have to make a .mp3 via process_video in order to get transcript (because AWS Transcribe does not support .webm); so don't trigger here
      make_video_bool = true;
    }
    if (this.props.audioType === 'record_video_per_slide') {
      make_video_bool = true;
      video_assembly_method = 'slide_video';
    }
    
    let PatchImageInPresentation = {
        video_assembly_method,
        "trigger_create_presentation_video": make_video_bool,
        //"trigger_create_presentation_pptx": make_video_bool,
        //"trigger_create_presentation_transcript": make_transcript_bool,
    }      

    //console.log("Final presentation patch for trigger and audio options",JSON.stringify(PatchImageInPresentation,null,2));
    console.log("Final presentation patch for trigger and audio options");

    await axios.patch(`${presentation_Creation_API}/${this.props.presentation_info.entity_uuid}`, PatchImageInPresentation, myHeaders_Autorized);
    
    // sleep for 2s so My PKs displays processing properly
    if (make_video_bool || make_transcript_bool) {
      this.setState({
        message: 'Starting Presentation Video Creation Process'
      })

      setTimeout(() => {
        this.props.next();
      }, 2000);
    } else {
      this.props.next();
    }
    return;
  }

  // API Calls for uploading recorded/uploaded audio, and then triggering video/transcribe creation
  AudioPushMet = async () => {
    console.log("AudioPushMet");

    // make sure we have audio...tricky because if there is already audio (edit) and it didn't change, we won't have audioOutput
    /*
    if (!this.state.final_local_file_url) {
      this.setState({ audioOutputValidate: true, modalLoader: false });
      return;
    }
    */

    // get language abbreviation value for database
    let language_abbreviation = "en-US"; // default if something went horribly wrong
    for (let language_obj of this.state.languageSelections) {
      if (language_obj['language'] === this.state.languageSelection) {
        language_abbreviation = language_obj.type;
      }
    }

    let presentationEntityId = this.props.presentation_info.entity_uuid;

    if (presentationEntityId === null) {
      console.error("ERROR - no presentation uuid");
      return false;
    }

    //this.setState({ modalLoader: true });

    if (this.state.audioChanged && (this.props.audioType === 'record_video' || this.props.audioType === 'upload_video')) {
      console.log("Uploading video",this.state.audioOutput_array);
      
        let final_audioOutput = this.state.audioOutput;
        //let slide_obj = this.props.slides_array[i];

        let audioPromise;
        let audioPromise_response;
        //let self = this;
        if (final_audioOutput) {
          audioPromise = new Promise(resolve => {
            let reader = new FileReader();
            reader.readAsArrayBuffer(final_audioOutput);
            reader.onload = () => resolve(reader.result);
          });
          audioPromise_response = await audioPromise;
        } else {
          // this is not ok
          return false;
        }
        
        if (!audioPromise_response) {
          console.error("Audio File Data Read Failed!")
          return false;
        }

        let tmp_audio_filename = this.state.audioFileName.toLowerCase().replace(/[\s,&']/g, "-");
        tmp_audio_filename = sanitize(tmp_audio_filename);
        //let tmp_audio_filename = slide_obj.entity_name+'.webm';
        //let tmp_audio_filename = 'presenter_video.webm';
        //tmp_audio_filename = sanitize(tmp_audio_filename);
        
        let response = await axios.post(`${apiUrl}presentations/${this.props.presentation_info.entity_uuid}/getUploadSignedUrl?asset_type=presenter_video&filename=${tmp_audio_filename}`, myHeaders_Autorized);
        if (response === null) {
          console.error("ERROR - presenter presenter_video getUploadSignedUrl FAILED");
          return false;
        }
        
        let dataRes = response.data;
        let audio_length_bytes = audioPromise_response.byteLength;
        const config = {
          headers: {
            "Content-Type": dataRes.content_type,
            "Content-Disposition": "attachment"
          },
          onUploadProgress: (progressEvent) => {
            let upload_percent = Math.floor(progressEvent.loaded / audio_length_bytes * 100);
            //console.log("AUDIO UPLOADING PROGRESS",progressEvent.loaded,upload_percent);
            this.setState({
              message: 'Presenter Video: Uploaded '+upload_percent+'%'
            });
          }
        };
        // audio upload
        await axios.put(dataRes.upload_url, audioPromise_response, config);
        
        this.setState({
          ok_to_finish: true,
          audioOutput: null
        });
    } else if (this.state.audioChanged && this.props.audioType === 'record_video_per_slide') {
      console.log("Uploading video per slide",this.state.audioOutput_array);
      //let tmp_audioOutput_array = [...this.state.audioOutput_array];
      
      let tmp_new_recording_flag_array = [...this.state.new_recording_flag_array];
      
      for (let i = 0; i < this.state.audioOutput_array.length; i++) {
        if (!this.state.new_recording_flag_array[i]) {
          // already uploaded this, or there is no audio
          console.log("Already uploaded video for slide ",i);
          continue;
        }
        
        let tmp_audioOutput = this.state.audioOutput_array[i];
        let slide_obj = this.props.slides_array[i];

        let audioPromise;
        let audioPromise_response;
        //let self = this;
        if (tmp_audioOutput) {
          audioPromise = new Promise(resolve => {
            let reader = new FileReader();
            reader.readAsArrayBuffer(tmp_audioOutput);
            reader.onload = () => resolve(reader.result);
          });
          audioPromise_response = await audioPromise;
        } else {
          // this is ok (for now) if we don't have data for every slide
          continue;
        }
        
        if (!audioPromise_response) {
          console.error("Audio File Data Read Failed!")
          return false;
        }

        //let tmp_audio_filename = slide_obj.entity_name+'.webm';
        //let tmp_audio_filename = 'slide_'+(i+1)+'_'+(new Date().getTime())+'.webm';
        let tmp_audio_filename = this.state.audioFileName.toLowerCase().replace(/[\s,&']/g, "-");
        tmp_audio_filename = sanitize(tmp_audio_filename);

        //tmp_audio_filename = sanitize(tmp_audio_filename);
        
        let response = await axios.post(`${apiUrl}slides/${slide_obj.entity_uuid}/getUploadSignedUrl?asset_type=presenter_video&filename=${tmp_audio_filename}`, myHeaders_Autorized);
        if (response === null) {
          console.error("ERROR - slide presenter_video getUploadSignedUrl FAILED");
          return false;
        }
        
        let dataRes = response.data;
        let audio_length_bytes = audioPromise_response.byteLength;
        const config = {
          headers: {
            "Content-Type": dataRes.content_type,
            "Content-Disposition": "attachment"
          },
          onUploadProgress: (progressEvent) => {
            let upload_percent = Math.floor(progressEvent.loaded / audio_length_bytes * 100);
            //console.log("AUDIO UPLOADING PROGRESS",progressEvent.loaded,upload_percent);
            this.setState({
              message: 'Slide '+(i+1)+' Video: Uploaded '+upload_percent+'%'
            });
          }
        };
        
        // audio upload
        await axios.put(dataRes.upload_url, audioPromise_response, config);
        tmp_new_recording_flag_array[i] = null; // so we know we already uploaded this
        //tmp_audioOutput_array[i] = null;

      }
      this.setState({
        new_recording_flag_array: tmp_new_recording_flag_array
        //audioOutput_array: tmp_audioOutput_array
      })
    } else {
      return false;
    }

    let patch_obj = {
      language_abbreviation: language_abbreviation,
      presenter_overlay_position: this.state.presenter_overlay_position
    }      

    console.log("Saving language_abbreviation, presenter_overlay_position");

    await Promise.all([
      axios.patch(`${presentation_Creation_API}/${presentationEntityId}`, patch_obj, myHeaders_Autorized)
    ]);
    

    /*    
    let PatchImageInPresentation = {
        "presenter_overlay_position": this.state.presenter_overlay_position,
        "language_abbreviation": language_abbreviation,
        "audio_delay": 0,
    }      

    //console.log("Final presentation patch for trigger and audio options",JSON.stringify(PatchImageInPresentation,null,2));
    console.log("Saving language, audio_delay");

    await axios.patch(`${presentation_Creation_API}/${presentationEntityId}`, PatchImageInPresentation, myHeaders_Autorized);

    this.setState({
      message: '',
    })
    */

    return true;
  }

  recordNextSlide = () => {
    /*
    console.log("recordNextSlide",this.state.current_slide);
    let new_timerCount = this.state.current_slide * this.state.seconds_per_slide;
    this.controlAudio('recording', this.state.current_slide+1);
    */
    console.log("recordNextSlide",this.state.carousel_active_slide_index);
    let new_timerCount = (this.state.carousel_active_slide_index+1) * this.state.seconds_per_slide;
    this.controlAudio('init_recording', this.state.carousel_active_slide_index+1);

    this.setState({ force_timerCount: new_timerCount });
  }

  /*
  resetPresentationRecording = () => {
    console.log("resetPresentationRecording");

    let new_state = {
      ok_to_finish: false, // do we have enough audio to finish/upload?
      audioMimeType: null, // returned from RecorderService so <audio>/<video> tag knows what to display
      force_timerCount: null, // for forcing AudioTimer to a different slide
      current_slide: 1, // for recording per-slide, controlled by dropdown
      required_slide_count: this.props.presentation_info.slide_count,
      seconds_per_slide: this.props.presentation_info.slide_length,
      max_wrapup_time: 0, // no wrapup time for record per-slide
      slide_indicator: '', // for audio control to display slide number
      showRecordControls: true,
      duration: 0, // recorded audio duration - gotten from AudioTimer
      autoplay: false, // tells RBCarousel whether to play or not
      //clickArea: null, // recording state value passed to AudioTimer, retrieved from AudioRecorder callback
      modified_slide_image_urls: [], // passed to RBCarousel to show slides during recording

      final_audioOutput: null, // actual raw recorded/uploaded data - entire presentation
      final_local_file_url: null, // file reference for entire presentation audio control
      audioOutput: null, // actual raw recorded/uploaded data - for one slide
      local_file_url: null, // specifically so audio control can reference - for one slide
      audioOutput_array: Array.apply(null, Array(this.props.presentation_info.slide_count)).map(function () {return null;}), // multi-slide recording, actual raw recorded/uploaded data
      local_file_url_array: Array.apply(null, Array(this.props.presentation_info.slide_count)).map(function () {return null;}), // multi-slide recording, specifically so audio control can reference
      audioName: null, // recorded audio filename, received from AudioRecorder
      audioOutputValidate: false, // show "please provide valid audio" message
      audioDelayValidate: false, // show "please use less than 300s for audio delay" message

      modalLoader: false, // show "audio uploading" message

      delayTime: 0, // introduction time, set in text field
      audioRecordstatus: null, // passed to AudioRecorder, changed by user clicking "record"/"pause"/"finish"
      audioChanged: false, // when uploading, was a new file uploaded?
      audio_delay_changed: false,
      language_selection_changed: false,
      languageSelections: supported_languages,

      languageSelection: "US English (en-US)", // default
      audioFileName: null, // uploaded audio filename, for display purposes
    }
    
    this.setState(new_state);
    
  }
  */

  controlAudio (audioRecordstatus, carousel_active_slide_index = this.state.carousel_active_slide_index) {
    
    console.log("controlAudio",this.state.audioRecordstatus,'->',audioRecordstatus, carousel_active_slide_index);
    let new_state = {...this.state};
    
    new_state.carousel_active_slide_index = carousel_active_slide_index;
    
    switch (audioRecordstatus) {
      case null: {
        // restart
        new_state.ok_to_finish = false;
        new_state.carousel_active_slide_index = 0;
        new_state.force_timerCount = 0;
        new_state.audioOutput = null; // actual raw recorded/uploaded data - for one slide
        new_state.local_file_url = null;
        new_state.audioOutput_array = Array.apply(null, Array(this.props.presentation_info.slide_count)).map(function () {return null;}); // multi-slide recording, actual raw recorded/uploaded data
        new_state.local_file_url_array = Array.apply(null, Array(this.props.presentation_info.slide_count)).map(function () {return null;}); // multi-slide recording, specifically so audio control can reference
        if (this.recorded_video_ref.current) {
          this.recorded_video_ref.current.srcObject = null;
          this.recorded_video_ref.current.src = null;
          this.prev_recorded_video_ref.current = this.recorded_video_ref.current;
        }
        break;
      }
      case 'init_recording': {}
      case 'recording': {
        // start fresh recording or unpaused recording
        // in case we were viewing other slides
        if (this.recorded_video_ref.current) {
          this.recorded_video_ref.current.muted = true;
        }

        /*
        if (this.state.audioRecordstatus === null) {
          // if this is a fresh start, make sure we are showing first slide
          new_state.carousel_active_slide_index = 0;
          new_state.force_timerCount = 0;          
        }
        */

        new_state.local_file_url = null;
        let tmp_local_file_url_array = this.state.local_file_url_array;
        tmp_local_file_url_array[carousel_active_slide_index] = null;
        new_state.local_file_url_array = tmp_local_file_url_array;

        break;
      }
      case 'recording_paused': {
        // pause recording
        //new_state.carousel_controls_bool = false;
        break;
      }
      case 'finished': {
        // we have completed recording
        //new_state.carousel_controls_bool = true;
        break;
      }
      case 'finishslide': {
        // we have completed recording one slide
        //new_state.carousel_controls_bool = true;
        break;
      }
      case 'playing': {
        // playing completed recording
        //new_state.carousel_controls_bool = true;
        console.log(" playing",this.recorded_video_ref.current.currentTime,this.recorded_video_ref.current.duration);
        if (this.recorded_video_ref.current) {
          if (this.recorded_video_ref.current.currentTime < this.recorded_video_ref.current.duration) {
            this.recorded_video_ref.current.muted = false;
            this.recorded_video_ref.current.play();
          } else if (this.recorded_video_ref.current.currentTime >= this.recorded_video_ref.current.duration) {
            this.recorded_video_ref.current.currentTime = 0;
            this.recorded_video_ref.current.muted = false;
            this.recorded_video_ref.current.play();
          }
          //if (this.recorded_video_ref.current.paused) {
          //  this.recorded_video_ref.current.play();
          //}
        }
        break;
      }
      case 'playing_paused': {
        // playing completed recording - paused
        //new_state.carousel_controls_bool = true;
        if (this.recorded_video_ref.current) {
          this.recorded_video_ref.current.pause();
        }
        break;
      }
    }
    
    new_state.audioRecordstatus = audioRecordstatus;
    new_state.fail_message = '';
    new_state.message = '';
    
    this.setState(new_state);
    
  }

  videoPlaySeek = (slide_index) => {
    let new_time;
    if (this.state.delayTime !== null) {
      // deal with cover image
      new_time = this.state.delayTime + ((slide_index-1) * this.state.seconds_per_slide);
    } else {
      new_time = slide_index * this.state.seconds_per_slide;
    }
    console.log("videoPlaySeek",slide_index,this.recorded_video_ref.current.duration,new_time);
    if (this.recorded_video_ref.current) {
      //console.log( "duration",this.recorded_video_ref.current.duration);
      //this.recorded_video_ref.current.currentTime = new_time;
      //console.log( "duration 2",this.recorded_video_ref.current.duration);
      
      // this.recorded_video_ref.current.duration is unreliable if recording!
      //if (this.props.audioType === 'upload') {
      console.log(" new_time duration 1",new_time,this.recorded_video_ref.current.duration);

      if (new_time < this.recorded_video_ref.current.duration) {
        this.recorded_video_ref.current.currentTime = new_time;
        if (this.state.audioRecordstatus === 'playing') {
          this.recorded_video_ref.current.play();
        }
      } else {
        this.recorded_video_ref.current.currentTime = this.recorded_video_ref.current.duration;
      }
      console.log(" new_time duration 2",new_time,this.recorded_video_ref.current.duration,this.recorded_video_ref.current.currentTime);

      //} else {
        
      //}
      //} else {
        //this.recorded_video_ref.current.currentTime = this.recorded_video_ref.current.duration;
      //}
    }
  }

  /*
  // audio upload autoplay start method
  seekRecording = () => {
    //console.log("seekRecording 1",this.recorded_audio_ref.current.currentTime,this.previous_seek_pos,this.state.delayTime);
    if (Math.abs(this.recorded_audio_ref.current.currentTime - this.previous_seek_pos) < 1) {
      //console.log("seekRecording bailout");
      return;
    } else {
      
    }
    clearInterval(this.auto_play_interval);
    
    let tmp_delay_time = this.state.delayTime;
    if (!tmp_delay_time) {
      tmp_delay_time = 0;
    }
    tmp_delay_time = parseInt(tmp_delay_time);
    
    let adjusted_time = this.recorded_audio_ref.current.currentTime;
    let start_at_zero = false;
    if (this.state.delayTime) {
      adjusted_time = adjusted_time - tmp_delay_time;
      if (adjusted_time < 0) {
        adjusted_time = 0;
        start_at_zero = true;
      }
    }
    let tmp_slide_number = Math.floor(adjusted_time / this.state.seconds_per_slide);
    
    // can't go over slide 20; meaning index 19 here
    if (tmp_slide_number >= this.state.required_slide_count) {
      tmp_slide_number = this.state.required_slide_count - 1;
    }
    
    //console.log("HMM",start_at_zero,tmp_slide_number,tmp_delay_time);
    if (this.rb_carousel_ref.current) {
      // seek to nearest slide break!
      if (start_at_zero && this.props.audioType === 'upload') {
        this.recorded_audio_ref.current.currentTime = 0;
        this.setState({slide_indicator:'Cover Slide / Introduction'});
        this.rb_carousel_ref.current.goToSlide(0);
      } else {
        
        this.recorded_audio_ref.current.currentTime = (tmp_slide_number * this.state.seconds_per_slide) + tmp_delay_time;
        this.setState({slide_indicator:'Slide '+(tmp_slide_number+1)});
        if (this.props.audioType === 'upload') {
          console.log("Going to slide "+(tmp_slide_number+1));
          this.rb_carousel_ref.current.goToSlide(tmp_slide_number+1);
        } else {
          this.rb_carousel_ref.current.goToSlide(tmp_slide_number);
        }
      }
      this.previous_seek_pos = this.recorded_audio_ref.current.currentTime;

      //console.log("seekRecording 2",this.recorded_audio_ref.current.currentTime,this.state.delayTime,adjusted_time,tmp_slide_number);
    } else {
      // navigated away maybe - do nothing
    }
  }
  */

  onSlideChange = (slide_index) => {
    let new_timerCount = slide_index * this.state.seconds_per_slide;
    console.log("onSlideChange",this.state.audioRecordstatus,slide_index,new_timerCount,this.state.local_file_url,this.state.local_file_url_array[slide_index]);
    
    if (this.props.audioType === "record_video_per_slide") {
      if (this.state.local_file_url_array[slide_index]) {
        // if we have already recorded this slide, show the audio control
        this.recorded_video_ref.current.srcObject = null;
        this.recorded_video_ref.current.src = this.state.local_file_url_array[slide_index];
        //this.recorded_video_ref.current.controls = true;
        this.prev_recorded_video_ref.current = this.recorded_video_ref.current;
        this.setState({
          audioRecordstatus: 'finishslide',
          carousel_active_slide_index: slide_index,
          local_file_url: this.state.local_file_url_array[slide_index],
          audioOutput: this.state.audioOutput_array[slide_index],
          //current_slide: e.target.value,
          force_timerCount: new_timerCount,
        });
      } else {
        // no audio recorded for this slide yet
        this.recorded_video_ref.current.srcObject = null;
        this.recorded_video_ref.current.src = null;
        //this.recorded_video_ref.current.controls = false;
        this.prev_recorded_video_ref.current = this.recorded_video_ref.current;
        this.setState({
          audioRecordstatus: 'finishslide',
          carousel_active_slide_index: slide_index,
          local_file_url: null,
          audioOutput: null,
          //current_slide: e.target.value,
          audioOutput: null,
          force_timerCount: new_timerCount,
        });
      }
    } else {
      this.setState({
        carousel_active_slide_index: slide_index
      })
    }
  }

  onCarouselSlideChange = (slide_index,direction) => {
    if (!this.state.showRecordControls || (this.state.audioRecordstatus && this.state.audioRecordstatus.endsWith('recording'))) {
      return;
    }
    this.onSlideChange(slide_index);
  }
  
  /*
  onCarouselSlideChange = (slide_index,direction) => {
    console.log("onCarouselSlideChange",this.state.audioRecordstatus,this.state.delayTime,slide_index,direction);
    // only allow this if we are not recording
    if (this.state.audioRecordstatus === 'recording' || this.state.audioRecordstatus === 'recording_paused') {
      return;
    }
    let new_timerCount;
    if (this.state.delayTime !== null) {
      if (slide_index === 0) {
        slide_index = 1;
      }
      new_timerCount = this.state.delayTime + (slide_index - 1) * this.state.seconds_per_slide;
    } else {
      new_timerCount = slide_index * this.state.seconds_per_slide;
    }
    //let new_timerCount = this.state.delayTime + slide_index * this.state.seconds_per_slide;
    this.setState({
      force_timerCount: new_timerCount,
      carousel_active_slide_index: slide_index
    });
    if (this.state.local_file_url) {
      this.videoPlaySeek(slide_index);
    }
  }
  */

  /*
  onAutoPlaySlideChange = (slide_number,direction) => {
    console.log("onAutoPlaySlideChange",slide_number,direction);
    
    if (!this.recorded_audio_ref.current) {
      // do nothing - we are recording
      return;
    }
    
    console.log("onAutoPlaySlideChange",slide_number,this.recorded_audio_ref.current.paused);
    if (!this.recorded_audio_ref.current.paused) {
      if (this.props.audioType === 'upload') {
        // handle cover slide
        if (slide_number === 0) {
          this.setState({slide_indicator: 'Cover Slide / Introduction'});
        } else {
          this.setState({slide_indicator: 'Slide '+slide_number});
        }
        
      } else if (this.state.audioRecordstatus === 'inactive') {
        // no cover slide
        this.setState({slide_indicator: 'Slide '+(slide_number+1)});
      }
    }
  }
  */

  /*
  // audio upload autoplay start method
  startRecording = (inc_delay_time) => {
    let tmp_delay_time;
    if (inc_delay_time && !isNaN(parseInt(inc_delay_time))) {
      tmp_delay_time = parseInt(inc_delay_time);
    } else {
      if (this.state.delayTime) {
        tmp_delay_time = parseInt(this.state.delayTime);
      } else {
        tmp_delay_time = 0;
      }
    }
    console.log("startRecording",tmp_delay_time,this.recorded_audio_ref.current.currentTime);
    clearInterval(this.auto_play_interval);
    // don't start slideshow until we get past intro
    if (tmp_delay_time && (this.recorded_audio_ref.current.currentTime < tmp_delay_time)) {
      let interval_ms = (tmp_delay_time - this.recorded_audio_ref.current.currentTime) * 1000;
      console.log("Intro - delaying autoplay",interval_ms);
      this.auto_play_interval = setInterval(() => {
        clearInterval(this.auto_play_interval);
        
        this.setState({
          autoplay: true,
        });
        this.setState({slide_indicator:'Slide 1'});
        this.rb_carousel_ref.current.goToSlide(1);
      }, interval_ms);
    } else if (this.recorded_audio_ref.current.currentTime < 0.01) {
      this.setState({slide_indicator:'Slide 1'});
      if (this.props.audioType === 'upload') {
        this.rb_carousel_ref.current.goToSlide(1);
      } else {
        this.rb_carousel_ref.current.goToSlide(0);
      }
      console.log("Autoplay started at Slide 1 with no audioDelay");
      this.setState({
        autoplay: true,
      })
    } else {
      console.log("Autoplay started");
      this.setState({
        autoplay: true,
      })
    }
  }
  */
  
  /*
  // audio upload autoplay pause method
  pauseRecording = () => {
    // jump to beginning of the current slide
    this.seekRecording();
    clearInterval(this.auto_play_interval);
    this.setState({
      autoplay: false,
    })
  }
  */
  

  // Audio file upload method
  onChangeAudioFile(event) {
    console.log("onChangeAudioFile",event.target.files);
    if (event.target.files[0] !== null && event.target.files[0] !== undefined) {
      let local_file_url = window.URL.createObjectURL(event.target.files[0]);
      console.log( "local_file_url",local_file_url);
      this.recorded_video_ref.current.srcObject = null;
      this.recorded_video_ref.current.src = local_file_url;
      
      // JBB - this takes some hacking to get the duration
      if (isNaN(this.recorded_video_ref.current.duration) || this.recorded_video_ref.current.duration === Infinity) {
        this.recorded_video_ref.current.onloadedmetadata = (async () => {
          this.recorded_video_ref.current.currentTime = 1000000;
          this.recorded_video_ref.current.ontimeupdate = (async () => {
            this.recorded_video_ref.current.ontimeupdate = null;
            console.log("Retrieved video duration (onChangeAudioFile)",this.recorded_video_ref.current.duration)
            this.recorded_video_ref.current.currentTime = 0;
            this.prev_recorded_video_ref.current = this.recorded_video_ref.current;
            //this.onCarouselSlideChange(0);
          });
        });
      } else {
        this.recorded_video_ref.current.currentTime = 0;
        this.prev_recorded_video_ref.current = this.recorded_video_ref.current;
        //this.onCarouselSlideChange(0);
      }
      //this.onCarouselSlideChange(0);
      
      //this.rb_carousel_ref.current.goToSlide(0);
      this.setState({
        carousel_active_slide_index: 0,
        audioOutput: event.target.files[0],
        //audioName: event.target.files[0].name,
        audioFileName: event.target.files[0].name,
        local_file_url: local_file_url,
        audioChanged: true,
        //audioOutputValidate:false,
        autoplay:false,
        //slide_indicator:'Cover Slide / Introduction'
      })
    }
  }
  

  onClickPre = () => {
    this.props.prev()
  }

  handleCancel = async () => {
    //let next_page = `${this.workspace_base_url}${local_routes.pklist}`;
    //this.props.history.push(next_page);
    
    let next_page = `${this.workspace_base_url}${local_routes.pklist}`;
    if (this.props.source_info && this.props.source_info.referrer) {
        next_page = this.props.source_info.referrer;
    }
    this.props.history.push(next_page);
  }

  toggleVideoStream = () => {
    this.setState({
      fail_message: '',
      show_video_stream: !this.state.show_video_stream,
      showing_video_stream: !this.state.show_video_stream ? true : false
    });
  }

  goFullScreen = () => {
    let elem = document.getElementById("fullscreen-container");
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.msRequestFullscreen) {
      elem.msRequestFullscreen();
    } else if (elem.mozRequestFullScreen) {
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) {
      elem.webkitRequestFullscreen();
    }
  }
  
  saveProgress = async () => {
    this.setState({
      message: 'Working...',
      saving: true,
      fail_message: null
    })
    await this.AudioPushMet();
    this.setState({
      saving: false,
      message: 'All changes saved'
    })
  }

  render() {
    let carousel_holder_class = 'carousel-holder-black';
    if (this.props.presentation_info.pad_color && this.props.presentation_info.pad_color === 'white') {
      carousel_holder_class = 'carousel-holder-white';
    }
    
    const audioProps = {
      recording_status: this.state.audioRecordstatus,
      show_video_stream: this.state.show_video_stream,

      getMediaStreamCallback: (stream) => {
        console.log("getMediaStreamCallback",stream);
        if (stream !== false) {
          this.recorded_video_ref.current.srcObject = stream;
          this.recorded_video_ref.current.muted = true;
          this.prev_recorded_video_ref.current = this.recorded_video_ref.current;
          this.recorded_video_ref.current.play();
          this.setState({ stream_ready: true, showing_video_stream: false });
        } else {
          if (this.recorded_video_ref.current) {
            this.recorded_video_ref.current.srcObject = null;
            //this.recorded_video_ref.current = null;
          }
          if (this.prev_recorded_video_ref.current) {
            this.prev_recorded_video_ref.current.srcObject = null;
            //this.prev_recorded_video_ref.current = null;
          }
          this.setState({ stream_ready: false, show_video_stream: false, showing_video_stream: false });
        }
      },

      //audioOutput_array: this.state.audioOutput_array,
      startCallback: (stream) => {
        console.log("startCallback",stream);

        //this.video_element.controls = false;
        //this.video_element.srcObject = stream;
        //this.video_element.play();


        //this.recorded_video_ref.current.controls = false;
        this.recorded_video_ref.current.srcObject = stream;
        this.prev_recorded_video_ref.current.srcObject = stream;
        this.recorded_video_ref.current.muted = true;
        this.recorded_video_ref.current.load();
        this.recorded_video_ref.current.play();
        //this.prev_recorded_video_ref.current = this.recorded_video_ref.current;

        //this.recorded_video_ref.current.src = null;
        //console.log(" SRC?",this.recorded_video_ref.current.currentSrc);
        this.setState({
          //clickArea: 'recording',
          audioRecordstatus: 'recording', // moving from init_recording to recording
          local_file_url: null,
          stream_ready: true
          //showRecordControls: true
        })
      },
      
      pauseCallback: () => {
        console.log("pauseCallback",this.state.duration);
        if (!this.state.show_video_stream) {
          this.recorded_video_ref.current.pause();
        }
        if (this.state.duration >= this.state.seconds_per_slide) {
          this.setState({
            //ok_to_finish: true
            //clickArea: 'paused',
            //showRecordControls: true,
          });
        }
      },
      
      unpauseCallback: (stream) => {
        console.log("unpauseCallback");
        if (!this.state.show_video_stream) {
          if (this.recorded_video_ref.current.paused) {
            this.recorded_video_ref.current.play();
          }
        }        
        //this.video_element.controls = false;
        //this.video_element.srcObject = stream;
        //this.video_element.play();


        //this.recorded_video_ref.current.controls = false;
        //this.recorded_video_ref.current.srcObject = stream;
        //this.recorded_video_ref.current.play();
        
        
        this.setState({
          //clickArea: 'recording',
          //showRecordControls: true
        })
      },
      
      // finish recording presentation/slide, ready to upload
      stopCallback: () => {
        console.log("stopCallback");
          this.setState({
            stream_ready: false,
            show_video_stream: false,
            //audioMimeType,
            //final_local_file_url: local_file_url,
            //final_audioOutput: audioOutput,
            
            //local_file_url: null,
            //clickArea: 'inactive',
            
            //audioName: `${this.props.PKCreationPresentationName}.mp3`,
            
            //showRecordControls: true
          })
      },

      /*
      stopCallback: (audioOutput,local_file_url,audioMimeType) => {
        console.log("stopCallback",local_file_url);
          this.setState({
            audioMimeType,
            final_local_file_url: local_file_url,
            final_audioOutput: audioOutput,
            local_file_url: null,
            clickArea: 'inactive',
            audioName: `${this.props.PKCreationPresentationName}.mp3`,
            showRecordControls: true
          })
      },
      */
      
      // when one slide is done processing
      finishCallback: (audioOutput,local_file_url,audioMimeType) => {
        console.log("finishCallback",local_file_url);
        
        this.recorded_video_ref.current.srcObject = null;
        this.prev_recorded_video_ref.current.srcObject = null;
        this.recorded_video_ref.current.src = local_file_url;
        this.prev_recorded_video_ref.current.src = local_file_url;
        
        //let audio_data_index = this.state.current_slide-2;
        let tmp_carousel_active_slide_index = 0;
        let audio_data_index = this.state.carousel_active_slide_index;
        let tmp_local_file_url = null;
        tmp_local_file_url = local_file_url;
        
        /*
        if (this.state.clickArea === 'paused') {
          // if this is a finish from finishSlide, vs from nextslide
          //audio_data_index = this.state.current_slide-1;
          audio_data_index = this.state.carousel_active_slide_index;
          tmp_local_file_url = local_file_url;
        }
        */

        
        if (this.state.audioRecordstatus === 'finishslide') {
          // if this is a finish from finishSlide, vs from finished
          //audio_data_index = this.state.current_slide-1;
          tmp_carousel_active_slide_index = this.state.carousel_active_slide_index;
          //tmp_local_file_url = local_file_url;
        }
        

        console.log(" local_file_url_array",this.state.local_file_url_array);
        let tmp_local_file_url_array = this.state.local_file_url_array;
        tmp_local_file_url_array[audio_data_index] = local_file_url;
        let tmp_audioOutput_array = this.state.audioOutput_array;
        tmp_audioOutput_array[audio_data_index] = audioOutput;
        let tmp_new_recording_flag_array = [...this.state.new_recording_flag_array];
        tmp_new_recording_flag_array[audio_data_index] = true;
        console.log(" tmp_local_file_url_array",tmp_local_file_url_array);
        console.log(" tmp_audioOutput_array",tmp_audioOutput_array);
        console.log(" tmp_new_recording_flag_array",tmp_new_recording_flag_array);

        // JBB - this takes some hacking to get the duration
        if (isNaN(this.recorded_video_ref.current.duration) || this.recorded_video_ref.current.duration === Infinity) {
          this.recorded_video_ref.current.onloadedmetadata = (async () => {
            if (!this.recorded_video_ref.current) {
              // not sure why this fires on unMount...but bailout if we dont have ref
              return;
            }
            this.recorded_video_ref.current.currentTime = 1000000;
            this.recorded_video_ref.current.ontimeupdate = (async () => {
              this.recorded_video_ref.current.ontimeupdate = null;
              console.log("Retrieved video duration (finishCallback)",this.recorded_video_ref.current.duration)
              this.recorded_video_ref.current.currentTime = 0;
              this.prev_recorded_video_ref.current = this.recorded_video_ref.current;
            });
          });
        } else {
          this.recorded_video_ref.current.currentTime = 0;
          this.prev_recorded_video_ref.current = this.recorded_video_ref.current;
        }

        // figure out if we are ok_to_finish
        //  if record_video_per_slide, we need video for every slide
        let ok_to_finish = true;
        if (this.props.audioType === 'record_video_per_slide') {
          for (let local_file_url of tmp_local_file_url_array) {
            if (!local_file_url) {
              ok_to_finish = false;
              break;
            }
          }
        }        
        let tmp_fail_message = '';
        
        /*
        let have_gap = false;
        let ok_to_finish = false;
        for (let local_file_url of tmp_local_file_url_array) {
          if (have_gap === false && local_file_url) {
            have_gap = false;
            ok_to_finish = true;
          } else if (have_gap && local_file_url) {
            // gap detected! bailout!
            ok_to_finish = false;
            break;
          } else {
            // missing file...this is ok if there are no gaps...eg we have recordings for slide 1 and 2, but not 3 through 20
            have_gap = true;
          }
        }

        
        if (have_gap && !ok_to_finish) {
          tmp_fail_message = "Audio gap detected - please make sure your audio is continuous before finishing"
        }
        */

        //console.log(" local_file_url_array",this.state.local_file_url_array);
        //console.log(" tmp_local_file_url_array",tmp_local_file_url_array);
        //console.log(" local_file_url",this.state.local_file_url);
        //console.log(" tmp_local_file_url",tmp_local_file_url);

        /*
        // is this the last slide?
        if (audio_data_index === tmp_local_file_url_array.length-1) {
          // we have them all - set to inactive to make AudioRecorder concat the audio files
          
          //this.controlAudio("inactive");
          //return;
        }
        */
        
        /*
        // figure out if we are ok_to_finish
        let have_gap = false;
        let ok_to_finish = false;
        for (let local_file_url of tmp_local_file_url_array) {
          if (have_gap === false && local_file_url) {
            have_gap = false;
            ok_to_finish = true;
          } else if (have_gap && local_file_url) {
            // gap detected! bailout!
            ok_to_finish = false;
            break;
          } else {
            // missing file...this is ok if there are no gaps...eg we have recordings for slide 1 and 2, but not 3 through 20
            have_gap = true;
          }
        }
        */

        let extension = "webm";
        if (audioMimeType.startsWith('video/mp4')) {
          extension = "mp4";
        }

        this.setState({
          audioChanged: true,
          audioMimeType,

          //show_video_stream: false,
          audioFileName: this.props.audioType === 'record_video' ? 'presenter_video_'+(new Date().getTime())+'.'+extension : 'slide_video_'+(new Date().getTime())+'.'+extension,
          //force_timerCount: 0,
          force_timerCount: tmp_carousel_active_slide_index * this.state.seconds_per_slide,
          //carousel_active_slide_index: 0, // ? for slide recording?
          carousel_active_slide_index: tmp_carousel_active_slide_index,
          
          //audioMimeType,
          local_file_url: tmp_local_file_url,
          local_file_url_array: tmp_local_file_url_array,
          audioOutput,
          audioOutput_array: tmp_audioOutput_array,
          new_recording_flag_array: tmp_new_recording_flag_array,
          
          showRecordControls: true,
          show_video_stream: false,
          stream_ready: false,
          ok_to_finish,
          fail_message: tmp_fail_message
        });
        
      },
      
      nextSlideCallback: () => {
        console.log("nextSlideCallback");
        //console.log(" local_file_url_array",this.state.local_file_url_array);
        this.setState({
          audioRecordstatus: 'inactive'
        });
      },
      
      // returned after a slide is done recording, but before actual audio is processed
      finishSlideCallback: () => {
        console.log("finishSlideCallback");
        
        this.setState({
          //clickArea: 'paused',
          showRecordControls: false,
          //audioRecordstatus: 'paused',
          //audioRecordstatus: null,
          force_timerCount: (this.state.carousel_active_slide_index * this.props.presentation_info.slide_length)
        });
      },
      
      failureCallback: () => {
        this.props.backToSelectAudio();
      }
    };
    
    let upload_button_text = "Upload File";
    if (this.state.audioFileName) {
      upload_button_text = "Upload New File";
    }

    return (
      <div className="container-fluid form-card" id="slides-carousel">   
        {
          this.state.message &&
            <p className="PKAudioSuccess flex-center">{this.state.message}</p>
        }
        {
          this.state.fail_message &&
            <p className="PKAudioError flex-center">{this.state.fail_message}</p>
        }

        {/* Validations */}
        {/*
        {
          this.state.audioDelayValidate === true ?
            <p className="PKAudioError flex-center">Audio delay should not have more that 300 seconds</p>
            :
            null
        }

        {
          this.state.audioOutputValidate === true ?
            <p className="PKAudioError flex-center">Please provide valid audio</p>
            :
            null
        }
        {
          this.state.modalLoader === true ?
            <p className="PKAudioSuccess flex-center">Audio Uploading</p>
            :
            null
        }
        */}

        <div id="fullscreen-container">
        <Container>
          <Row style={{ marginBottom: "10px" }} noGutters={true} className="justify-content-between">
            <Col xs={6} style={{ fontSize:"smaller", cursor: "pointer" }} onClick={() => this.props.backToSelectAudio()}>
                <i className="fa fa-angle-double-left"></i> Go Back to Select Audio
            </Col>
            <Col xs={6} style={{ whiteSpace: 'nowrap'}} className="flex justify-content-end">
            { (this.props.audioType === 'record_video_per_slide' && this.state.audioChanged) &&
              
              <Button
                variant="pkprimary"
                onClick={this.saveProgress}
                disabled={this.state.saving || (this.state.audioRecordstatus !== null && this.state.audioRecordstatus !== 'finishslide')}
              >
                Save Progress
              </Button>
              
            }              
              { (!this.state.local_file_url && this.props.audioType !== 'upload_video' && (this.state.audioRecordstatus === null || this.state.audioRecordstatus === 'finishslide') && !this.state.show_video_stream) &&
                  
                    <Button
                      style={{ marginLeft: "5px" }}
                      disabled={this.state.saving}
                      size="sm"
                      variant="outline-secondary"
                      onClick={this.toggleVideoStream}
                    >
                      Show Camera
                    </Button>
                  
              }
            </Col>
                    {/*
                    <ToggleButtonGroup
                      //style={{ whiteSpace: 'normal'}}
                      size="sm"
                      type="radio"
                      name="show_video_stream"
                      value={this.state.show_video_stream}
                      onChange={this.toggleVideoStream}
                    >
                      <ToggleButton
                        //style={{ whiteSpace: 'nowrap'}}
                        disabled={this.state.audioRecordstatus !== null}
                        size="sm"
                        variant="outline-secondary"
                        value={true}
                      >
                        {this.state.show_video_stream ? 'Showing Video' : 'Show Video'}
                      </ToggleButton>
                      <ToggleButton
                        //style={{ whiteSpace: 'nowrap'}}
                        disabled={this.state.audioRecordstatus !== null}
                        size="sm"
                        variant="outline-secondary"
                        value={false}
                      >
                        {this.state.show_video_stream ? 'Hide Video' : 'Hidden Video'}
                      </ToggleButton>

                    </ToggleButtonGroup>
                    */}


          </Row>
        
          <Row lg={12} md={12} sm={12} noGutters={true}>
            { (this.state.presenter_overlay_position === 'top_right' || this.state.presenter_overlay_position === 'bottom_right') &&
              <Col lg={2} md={2} sm={2}>
              </Col>
            }
          
            { (this.state.presenter_overlay_position === 'top_left') &&
              <Col lg={2} md={2} sm={2} className="align-self-start">
                <Row  style={{ position: 'relative', zIndex: 100 }}>
                  <video
                    style = {{ width: "100%" }}
                    ref={this.recorded_video_ref}
                    controls={false}
                    //controls="controls" 
                    //src={this.state.local_file_url} 
                    //type={this.state.videoMimeType}
                  />

                </Row>
              </Col>
            }
  
            { (this.state.presenter_overlay_position === 'bottom_left') &&
              <Col lg={2} md={2} sm={2} className="align-self-end">
                <Row style={{ marginBottom: "1px", position: 'relative', zIndex: 100 }}>
                  <video
                    style = {{ width: "100%" }}
                    ref={this.recorded_video_ref}
                    controls={false}
                    //controls="controls" 
                    //src={this.state.local_file_url} 
                    //type={this.state.videoMimeType}
                  />
                </Row>
              </Col>
            }
  
            <Col lg={8} md={8} sm={8}>
 
              <Row style={{ zIndex: 0 }}>
                <Carousel
                  activeIndex={this.state.carousel_active_slide_index}
                  style = {{ width: "100%" }}
                  //interval={this.state.seconds_per_slide * 1000}
                  interval={null}
                  wrap={false}
                  controls={false}
                  slide={false}
                  onSelect={this.onCarouselSlideChange}
                  ref={this.rb_carousel_ref}
                >
                  {this.state.modified_slide_image_urls.map((item,index) =>
                      <Carousel.Item key={index} className="carousel-img">
                        <img style={{ border:"1px solid black", width: "100%", height: "100%" }} src={item} alt="img"/>
                      </Carousel.Item>
                    )
                  }
                </Carousel>
              </Row>
            </Col>
            { (this.state.presenter_overlay_position === 'top_right') &&
              <Col lg={2} md={2} sm={2} className="align-self-start">
                <Row style={{ position: 'relative', zIndex: 100 }}>
                  <video
                    style = {{ width: "100%" }}
                    ref={this.recorded_video_ref}
                    controls={false}
                  />


                </Row>
              </Col>
            }
            { (this.state.presenter_overlay_position === 'bottom_right') &&
              <Col lg={2} md={2} sm={2} className="align-self-end">
                <Row style={{ marginBottom: "1px", position: 'relative', zIndex: 100 }}>
                  <video
                    style = {{ width: "100%" }}
                    ref={this.recorded_video_ref}
                    controls={false}
                  />
                </Row>
              </Col>
            }
          </Row>
        </Container>

        {
          (this.props.audioType === "record_video_per_slide" || this.props.audioType === "record_video" || this.props.audioType === "upload_video") &&
            // Recording Audio section
            // JBB 2/6/2020 - break this down per slide
            <Container>
            <Row>
              <Col lg={12}>
                <AudioTimer
                  delayTime={this.state.delayTime}
                  audioTimer_handler={this.audioTimer_handler}
                  //clickArea={this.state.clickArea}
                  audioRecordstatus={this.state.audioRecordstatus}
                  force_timerCount={this.state.force_timerCount}
                  seconds_per_slide={this.state.seconds_per_slide}
                  required_slide_count={this.state.required_slide_count}
                  //max_duration={this.max_duration}
                />
                
                <div className="audio-recording">
                  
                  <div className="recording btnControls">
                    { this.props.audioType === "record_video_per_slide" &&
                      <div className="btn-box recording-button">
                        { (this.state.showRecordControls && this.state.audioRecordstatus !== 'init_recording') ?
                          <div>
                            {/*
                            {(this.state.audioRecordstatus === null && !this.state.local_file_url) &&
                              <React.Fragment>
                              { (this.state.show_video_stream && this.state.stream_ready) ?
                                <Button
                                  //disabled={this.recorded_video_ref.current.srcObject === null || this.state.saving}
                                  disabled={this.state.saving}
                                  //className="btn-success"
                                  variant="pkprimary"
                                  onClick={() => this.controlAudio("recording")}
                                >
                                  Start Slide {this.state.carousel_active_slide_index+1} Recording
                                </Button>
                                :
                                <Button
                                  disabled={this.state.saving || this.state.showing_video_stream}
                                  //className="btn-success"
                                  variant="pkprimary"
                                  onClick={this.toggleVideoStream}
                                >
                                  Turn On Camera
                                </Button>
                              }
                              </React.Fragment>
                            }
                            */}
                            {((this.state.audioRecordstatus === null || this.state.audioRecordstatus === 'finishslide') && !this.state.local_file_url) &&
                              <Button
                                //disabled={this.recorded_video_ref.current.srcObject === null || this.state.saving}
                                disabled={this.state.saving}
                                //className="btn-success"
                                variant="pkprimary"
                                onClick={() => this.controlAudio("init_recording")}
                              >
                                Start Slide {this.state.carousel_active_slide_index+1} Recording
                              </Button>
                            }
                            {((this.state.audioRecordstatus === "finishslide" || this.state.audioRecordstatus === null) && this.state.local_file_url) &&
                              <Button
                                //className="btn-success"
                                style={{ margin: "5px" }}
                                variant="pkprimary"
                                disabled={this.state.saving}
                                onClick={() => this.controlAudio("init_recording")}>Restart Slide {this.state.carousel_active_slide_index+1} Recording</Button>}
                           { ((this.state.audioRecordstatus === "finishslide" || this.state.audioRecordstatus === null) && this.state.local_file_url && (this.state.carousel_active_slide_index < this.state.required_slide_count - 1)) &&
                              <Button
                                //className="btn-success"
                                style={{ margin: "5px" }}
                                variant="pkprimary"
                                disabled={this.state.saving}
                                onClick={() => this.recordNextSlide()}>Start Recording Next Slide ({this.state.carousel_active_slide_index+2}) </Button>}                            
                           { (this.state.local_file_url && this.state.audioRecordstatus !== "playing" && this.state.audioRecordstatus !== "playing_paused") &&
                              <Button
                                //className="btn-success"
                                variant="pkprimary"
                                disabled={this.state.saving}
                                onClick={() => this.controlAudio("playing")}>Play</Button>}
                            { (this.state.audioRecordstatus === "playing") &&
                              <Button
                                //className="btn-success"
                                variant="pkprimary"
                                disabled={this.state.saving}
                                onClick={() => this.controlAudio("playing_paused")}>Pause</Button>}    
                            { (this.state.audioRecordstatus === "playing_paused") &&
                              <Button
                                //className="btn-success"
                                variant="pkprimary"
                                disabled={this.state.saving}
                                onClick={() => this.controlAudio("playing")}>Resume</Button>}
                            {/*
                            {this.state.clickArea === null &&
                              <Button className="btn-success"
                                variant="secondary"
                                disabled={this.state.saving}
                                onClick={() => this.controlAudio("recording")}>Start Slide {this.state.current_slide} Recording</Button>}
                            {this.state.clickArea === "inactive" && this.state.local_file_url !== null &&
                              <Button className="btn-success"
                                variant="secondary"
                                disabled={this.state.saving}
                                onClick={() => this.controlAudio("recording")}>Restart Slide {this.state.current_slide} Recording</Button>}
                            {this.state.clickArea === "inactive" && this.state.final_local_file_url !== null &&
                              <Button className="btn-success"
                                variant="secondary"
                                disabled={this.state.saving}
                                onClick={() => this.resetPresentationRecording()}>Restart Presentation Recording</Button>}
                            {this.state.clickArea === "paused" && this.state.local_file_url !== null &&
                              <Button className="btn-success"
                                variant="secondary"
                                disabled={this.state.saving}
                                onClick={() => this.controlAudio("recording")}>Restart Slide {this.state.current_slide} Recording</Button>}
                            {this.state.clickArea === "paused" && this.state.local_file_url === null &&
                              <Button className="btn-success"
                                variant="secondary"
                                disabled={this.state.saving}
                                onClick={() => this.controlAudio("recording")}>Start Slide {this.state.current_slide} Recording</Button>}
                            { (this.state.clickArea === "paused" && this.state.local_file_url !== null && (this.state.current_slide < this.state.required_slide_count)) &&
                              <Button className="btn-success"
                                variant="secondary"
                                disabled={this.state.saving}
                                onClick={() => this.recordNextSlide()}>Start Recording Next Slide ({this.state.current_slide+1}) </Button>}
                            */}
                          </div>
                        :
                          <ActivityIndicator theme="button-Status-Loader" />
                        }
                      </div>
                    }
                    { this.props.audioType === "record_video" &&
                      <div className="btn-box recording-button">
                        { this.state.showRecordControls ?
                          <div>
                            {(this.state.audioRecordstatus === null && !this.state.local_file_url) &&
                              <React.Fragment>
                              { (this.state.show_video_stream && this.state.stream_ready) ?
                                <Button
                                  //disabled={this.recorded_video_ref.current.srcObject === null || this.state.saving}
                                  disabled={this.state.saving}
                                  className="btn-success"
                                  variant="secondary"
                                  onClick={() => this.controlAudio("init_recording")}
                                >
                                  Start Recording
                                </Button>
                                :
                                <Button
                                  disabled={this.state.saving || this.state.showing_video_stream}
                                  className="btn-success"
                                  variant="secondary"
                                  onClick={this.toggleVideoStream}
                                >
                                  Turn On Camera
                                </Button>
                              }
                              </React.Fragment>
                            }
                            {(this.state.audioRecordstatus === "playing_paused" || this.state.audioRecordstatus === "recording_paused" || this.state.local_file_url) &&
                              <Button className="btn-success"
                                variant="secondary"
                                disabled={this.state.saving}
                                onClick={() => this.controlAudio(null)}>Restart Recording</Button>}
                            {(this.state.local_file_url && this.state.audioRecordstatus !== "playing" && this.state.audioRecordstatus !== "playing_paused") &&
                              <Button className="btn-success"
                                variant="secondary"
                                disabled={this.state.saving}
                                onClick={() => this.controlAudio("playing")}>Play</Button>}
                            {(this.state.audioRecordstatus === "playing") &&
                              <Button className="btn-success"
                                variant="secondary"
                                disabled={this.state.saving}
                                onClick={() => this.controlAudio("playing_paused")}>Pause</Button>}
                           {(this.state.audioRecordstatus === "playing_paused") &&
                              <Button className="btn-success"
                                variant="secondary"
                                disabled={this.state.saving}
                                onClick={() => this.controlAudio("playing")}>Resume Playing</Button>}
                            {this.state.audioRecordstatus === "recording_paused" &&
                              <Button className="btn-success"
                                variant="secondary"
                                disabled={this.state.saving}
                                onClick={() => this.controlAudio("recording")}>Resume Recording</Button>}
                            {this.state.audioRecordstatus === "recording" &&
                              <Button className="btn-success"
                                variant="secondary"
                                disabled={this.state.saving}
                                onClick={() => this.controlAudio("recording_paused")}>Pause Recording</Button>}
                            {(this.state.audioRecordstatus === "recording" || this.state.audioRecordstatus === "recording_paused") && this.state.ok_to_finish &&
                              <Button className="btn-success"
                                variant="secondary"
                                disabled={this.state.saving}
                                onClick={() => this.controlAudio("finished")}>Finish Recording</Button>}
                          </div>
                        :
                          <ActivityIndicator theme="button-Status-Loader" />
                        }
                      </div>
                    }
                    
                    { this.props.audioType === "upload_video" &&
                      <div className="btn-box recording-button">
                        { this.state.showRecordControls ?
                          <div>
                            {(this.state.local_file_url && this.state.audioRecordstatus !== "playing" && this.state.audioRecordstatus !== "playing_paused") &&
                              <Button className="btn-success"
                                variant="secondary"
                                disabled={this.state.saving}
                                onClick={() => this.controlAudio("playing")}>Play Presentation</Button>}
                            {(this.state.audioRecordstatus === "playing") &&
                              <Button className="btn-success"
                                variant="secondary"
                                disabled={this.state.saving}
                                onClick={() => this.controlAudio("playing_paused")}>Pause Presentation Playing</Button>}
                           {(this.state.audioRecordstatus === "playing_paused") &&
                              <Button className="btn-success"
                                variant="secondary"
                                disabled={this.state.saving}
                                onClick={() => this.controlAudio("playing")}>Resume Presentation Playing</Button>}
                          </div>
                        :
                          <ActivityIndicator theme="button-Status-Loader" />
                        }
                      </div>
                    }                    
                  </div>
                  { this.props.audioType !== "upload_video" &&
                    <div className="center upload-audiofile">
                      <VideoRecorder
                        {...audioProps}
                      />
                    </div>
                  }
                </div>
              </Col>
            </Row>
            </Container>
        }
        </div>
        <div>
          <Form>
            { this.props.audioType === "record_video_per_slide" &&
              <Form.Group controlId="current_slide">
                <div className="form-dropdownlist lang-dropdownlist">
                  <Form.Label>Select Slide to Record</Form.Label>
                  <Form.Control
                    as="select"
                    required
                    disabled={!this.state.showRecordControls || (this.state.audioRecordstatus && this.state.audioRecordstatus.endsWith('recording'))}
                    onChange={this.handleSlideChange}
                    value={this.state.carousel_active_slide_index+1}
                  >
                    {
                      this.state.local_file_url_array.map((local_file_url,index) => {
                        let slide_number = index+1;
                        return <option value={slide_number} key={slide_number}>Slide {slide_number}{local_file_url ? ' RECORDED' : ''}{local_file_url && !this.state.new_recording_flag_array[index] ? ' SAVED' : ''}</option>;
                        /*
                        if (local_file_url && this.state.audioOutput_array[index]) {
                          return <option value={slide_number} key={slide_number}>Slide {slide_number} RECORDED UNSAVED</option>;
                        } else if (local_file_url) {
                          return <option value={slide_number} key={slide_number}>Slide {slide_number} RECORDED SAVED</option>;
                        } else if (this.state.current_slide-1 === index) {
                          return <option value={slide_number} key={slide_number}>Slide {slide_number}</option>;
                        }
                        */
                      })
                    }
                  </Form.Control>
                </div>
              </Form.Group>
            }
            {/* Overlay position */}
            <Form.Group controlId="presenter_overlay_position">
              <div className="form-dropdownlist lang-dropdownlist">
                <Form.Label>Presenter Overlay Position</Form.Label>
                <Form.Control
                  as="select"
                  required
                  onChange={this.handleOverlayPositionChange}
                  value={this.state.presenter_overlay_position}
                  disabled={!this.state.showRecordControls || (this.state.audioRecordstatus && this.state.audioRecordstatus.endsWith('recording'))}
                >
                  {
                    this.presenter_overlay_positions.map((item) =>
                      <option key={item.value} value={item.value}>{item['display']}</option>
                    )
                  }
                </Form.Control>
              </div>
            </Form.Group>

            {/* Language Selection dropdown */}
            <Form.Group controlId="languageSelection">
              <div className="form-dropdownlist lang-dropdownlist">
                <Form.Label>Language (for transcription)</Form.Label>
                <Form.Control
                  as="select"
                  required
                  onChange={this.handleLanguageChange}
                  value={this.state.languageSelection}
                >
                  {
                    this.state.languageSelections.map((item) =>
                      <option key={item.type}>{item['language']}</option>
                    )
                  }
                </Form.Control>
              </div>
            </Form.Group>

            {/* Audio delay in upload option */}
            { (this.props.audioType === "upload") &&
              <Form.Group controlId="audioDelay">
                    <div className="form-dropdownlist">
                      <Form.Label>Intro Length (seconds until first slide)</Form.Label>
                      <Form.Control
                        required
                        type="number"
                        min="0"
                        max="300"
                        placeholder="In seconds - 300 maximum"
                        onChange={this.handleAudioDelayChange}
                        onKeyPress={this.onKeyPress.bind(this)}
                        value={this.state.delayTime}
                      />
                    </div>
              </Form.Group>
            }
          </Form>
        </div>
        

        {
          this.props.audioType === "upload_video" &&
            // Upload audio section
            <div>
              <div className=" upload-audio flex-center">
                <Button disabled={this.state.saving} className="btn btn-danger btn-global">
                  {upload_button_text}
                  <form className="uploader" encType="multipart/form-data">
                    <input
                      type="file"
                      accept="video/mp4,video/webm"
                      onChange={e => this.onChangeAudioFile(e)}
                    />
                  </form>
                </Button>
              </div>
              <br/>
              <div style={{ display: this.state.local_file_url ? "block" : "none" }}
                className="center upload-audiofile">
                {this.state.audioFileName ?
                  <div>
                  {/* <span>{this.state.slide_indicator}<br/></span> */}
                  <span>Current presenter video filename: {this.state.audioFileName}<br/></span>
                  </div>
                  :
                  null
                }

                {/*
                <audio
                  style = {{ width: "100%" }}
                  ref={this.recorded_audio_ref}
                  controls="controls" 
                  src={this.state.local_file_url} 
                  onSeeked={this.seekRecording}
                  onPause={this.pauseRecording}
                  onPlay={this.startRecording}
                />
                */}
              </div>
            </div>
        }
         
        {/* Previous & Publish buttons */}
        <div className="form-group btn-position">
                    <button
                      className="btn btn-draft"
                      onClick={this.onClickPre}
                      disabled={this.state.saving}
                    >
                      Previous
                    </button>
                    <button
                      className="btn btn-draft"
                      onClick={() => this.handleCancel()}
                      disabled={this.state.saving}
                    >
                      Cancel
                    </button>
                    {/*
                    <button style={{ marginRight: "7px" }} className="btn btn-publish" onClick={this.AudioPushMet}>
                      Save Progress
                    </button>
                    */}
                    <button
                      className="btn btn-publish"
                      onClick={this.TriggerCreateVideo}
                      disabled={this.state.saving}
                    >
                      Finish (Save + Create Video)
                    </button>
        </div>
      </div>
    ); // end return
  } // end render
}

export default withRouter(Presentation);
